<!--
 * @Author: AI Assistant
 * @Date: 2025-12-30
 * @Description: 音乐模式切换组件（人声歌曲/纯音乐）
 * @FilePath: /weryai-web/components/Tool/MusicModeSwitch.vue
-->
<template>
    <div class="mb-6">
        <div class="flex bg-[#1A1A1A] p-1 rounded-lg">
            <button
                v-for="option in modeOptions"
                :key="option.value"
                @click="mode = option.value"
                class="flex-1 py-2 px-4 text-sm font-medium rounded-md transition-all duration-200"
                :class="[
                    mode === option.value
                        ? 'bg-[#2A2A2E] text-white'
                        : 'text-[#A0A0A8] hover:text-white'
                ]"
            >
                {{ option.label }}
            </button>
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from '~/composables/useI18n'

const { t } = useI18n()

const mode = defineModel<'vocal' | 'inst'>('mode', {
    default: 'vocal',
})

const modeOptions = computed(() => [
    { value: 'vocal' as const, label: t('music.vocalSong') },
    { value: 'inst' as const, label: t('music.instrumental') },
])
</script>

<style scoped>
/* 组件样式已通过 Tailwind 内联实现 */
</style>

